module.exports = __webpack_public_path__ + "static/media/info-hexagon-grey-circle.89aa6795.svg";